import "react-phone-number-input/style.css";
import ReactPhoneNumberInput from "react-phone-number-input";
import React from "react";
import noop from "lodash/noop";

import Input from "../Input";
import FieldWrapper from "../FieldWrapper";

import { PhoneNumberWithPrefixInputProps } from "./types";

const PhoneNumberWithPrefixInput: React.FC<PhoneNumberWithPrefixInputProps> = ({
  onChange = noop,
  error,
  ...props
}) => (
  <FieldWrapper
    {...{ error }}
    controller={
      <ReactPhoneNumberInput
        limitMaxLength
        addInternationalOption={false}
        defaultCountry="US"
        initialValueFormat="national"
        inputComponent={Input}
        {...{ ...props, onChange }}
      />
    }
  />
);

export default PhoneNumberWithPrefixInput;
